export enum URLS {
	MI_MUTUAL = 'mi-mutual/orders',
	MI_MUTUAL_DETAIL = 'mi-mutual/logs',
	RELIANCE_FIRST = 'reliance-first/orders',
	RELIANCE_FIRST_DETAIL = 'reliance-first/logs'
};

export enum ORIGIN  {
	MI_MUTUAL = 'Mi Mutual',
	RELIANCE_FIRST = 'Reliance First'
}

export class FiltersModel {
	private _filters: {};

	constructor(customFilters: {}) {
		this._filters = customFilters;
	}

	get filters(): {} {
		return this._filters;
	}
};

export const LOGS = {
	RELIANCE_FIRST: 'Reliance First Logs',
	MI_MUTUAL: 'Mi Mutual Logs'
};

export interface OriginSourceData {
	isDirty?: boolean;
	origin?: string;
	reload?: boolean;
	isHeaderChange?: boolean;
}